import React from "react";

interface IPropsDashboardListBar {
    statusValue: number,
    colorHash: string,
    hasValue?: boolean,
    statusScale: number,
    darkBg?: boolean
}

export const DashboardListBar: React.FC<IPropsDashboardListBar> = ({darkBg = true, statusValue, colorHash, statusScale = 0, hasValue = true}) => {
    return (
        <>
            {
                statusValue !== 0 &&
                Array.from({ length: statusValue }).map((_, index) => (
                    <div
                        key={index} // Dodajemo key za svaku instancu
                        className={`dashboard-item__bar--segment dashboard-item__bar--segment-${darkBg ? 'darkBg' : 'lightBg'}`}
                        style={{ width: `${statusScale}%`, backgroundColor: `${colorHash}` }}
                    >
                        {/* {statusValue >= 1 && statusValue} */}
                    </div>
                ))
            }
        </>
    )
}